export default __webpack_public_path__ + "static/tech-nation-2-29bad2aae56d6caa65400cbd788dc336.png";